import { ConfigurationTab as Component } from './component';
import { ConnectorProps } from './ConfigurationTab.proptype';
import Connector from './connector';

export interface ConfigurationTabProps extends Omit<ConnectorProps, 'component'> {}

export const ConfigurationTab = (props: ConfigurationTabProps) => <Connector {...props} component={Component} />;
